"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtmParameters = exports.notifcationSubType = exports.WebhookType = exports.WebhookTypeIterable = exports.EmailType = exports.CapitalProviderEmailType = exports.CapitalProviderEmailTypeIterable = exports.BorrowerSlackNotificationType = exports.BorrowerSlackNotificationTypeIterable = exports.BorrowerSlackTypeDEPRECATED = exports.BorrowerSlackTypeDEPRECATEDIterable = exports.BorrowerEmailType = exports.BorrowerEmailTypeIterable = exports.SlackGroups = exports.SlackGroupsIterable = void 0;
// Re-export everything from common
var common_1 = require("./common");
Object.defineProperty(exports, "SlackGroupsIterable", { enumerable: true, get: function () { return common_1.SlackGroupsIterable; } });
Object.defineProperty(exports, "SlackGroups", { enumerable: true, get: function () { return common_1.SlackGroups; } });
Object.defineProperty(exports, "BorrowerEmailTypeIterable", { enumerable: true, get: function () { return common_1.BorrowerEmailTypeIterable; } });
Object.defineProperty(exports, "BorrowerEmailType", { enumerable: true, get: function () { return common_1.BorrowerEmailType; } });
Object.defineProperty(exports, "BorrowerSlackTypeDEPRECATEDIterable", { enumerable: true, get: function () { return common_1.BorrowerSlackTypeDEPRECATEDIterable; } });
Object.defineProperty(exports, "BorrowerSlackTypeDEPRECATED", { enumerable: true, get: function () { return common_1.BorrowerSlackTypeDEPRECATED; } });
Object.defineProperty(exports, "BorrowerSlackNotificationTypeIterable", { enumerable: true, get: function () { return common_1.BorrowerSlackNotificationTypeIterable; } });
Object.defineProperty(exports, "BorrowerSlackNotificationType", { enumerable: true, get: function () { return common_1.BorrowerSlackNotificationType; } });
Object.defineProperty(exports, "CapitalProviderEmailTypeIterable", { enumerable: true, get: function () { return common_1.CapitalProviderEmailTypeIterable; } });
Object.defineProperty(exports, "CapitalProviderEmailType", { enumerable: true, get: function () { return common_1.CapitalProviderEmailType; } });
Object.defineProperty(exports, "EmailType", { enumerable: true, get: function () { return common_1.EmailType; } });
Object.defineProperty(exports, "WebhookTypeIterable", { enumerable: true, get: function () { return common_1.WebhookTypeIterable; } });
Object.defineProperty(exports, "WebhookType", { enumerable: true, get: function () { return common_1.WebhookType; } });
Object.defineProperty(exports, "notifcationSubType", { enumerable: true, get: function () { return common_1.notifcationSubType; } });
// Re-export UtmParameters namespace as module
exports.UtmParameters = __importStar(require("./UtmParameters"));
//# sourceMappingURL=index.js.map